var _clipPath;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularSquareSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 0,
    width: 0,
    style: {
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "boonCircularSquareClipPath",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0 C0.111111109,0 0,0.111111109 0,0.5 C0,0.888888891 0.111388891,1 0.5,1 C0.888611109,1 1,0.888888891 1,0.5 C1,0.28876063 0.967134478,0.159480167 0.874825587,0.0854472053 C0.797195029,0.0231864624 0.677522626,0 0.5,0 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularSquareSvg);
export default __webpack_public_path__ + "static/media/CircularSquareSvg.7b98755a758801025b4d81f85e69a1eb.svg";
export { ForwardRef as ReactComponent };